const OauthUrl = window.api?.API_BASE_ROUTE; // "http://192.168.40.8:5011";
const MarketDataUrl = window.api?.API_INDEX_ROUTE; // "http://192.168.40.8:7000";
const ResourceUrl = window.api?.API_RESOURCE_ROUTE;

const apiRoutes = {
  captch: {
    Get: OauthUrl + '/Captcha/v1/create',
  },
  Authorization: {
    Post: OauthUrl + '/OAuthApi/v1/Authorization',
  },
  twoFactor: {
    Post: OauthUrl + '/OAuthApi/v1/TwoFactorAuthorizer',
    MobileRequest: OauthUrl + '/TwoFactor/v1/MobileRequest',
    TurnOffMobileState: OauthUrl + '/TwoFactor/v1/TurnOffMobileState',
    TurnOnMobileState: OauthUrl + '/TwoFactor/v1/TurnOnMobileState',
  },
  logout: {
    Post: OauthUrl + '/OAuthApi/v1/Logout',
  },
  forgetPassword: {
    Request: OauthUrl + '/ForgetPassword/v1/Request',
    Validation: OauthUrl + '/ForgetPassword/v1/ValidationWithCaptcha',
    ChangePassword: OauthUrl + '/ForgetPassword/v1/ChangePassword',
  },
  retrySms: {
    Post: OauthUrl + '/OTP/v1/RetrySms',
  },
  changePassword: {
    Post: OauthUrl + '/ChangePassword/v1/ChangePassword',
    RequestPost: OauthUrl + '/ChangePassword/v1/Request',
    RequestGEt: OauthUrl + '/ChangePassword/v1/Request',
    ValidationWithCaptcha:
      OauthUrl + '/ChangePassword/v1/ValidationWithCaptcha',
  },
  forceChangePassword: {
    Request: OauthUrl + '/ForceChangePassword/v1/Request',
    Validation: OauthUrl + '/ForceChangePassword/v1/ValidationWithCaptcha',
    ChangePassword: OauthUrl + '/ForceChangePassword/v1/ChangePassword',
  },
  Index: {
    Get: MarketDataUrl + '/LoginIndex/v1',
  },
  Resource: {
    Get:
      ResourceUrl + `/JsonResource/${window.api?.APP_RESOURCE_NAME}_Fa_00.json`,
  },
  AccountActivation: {
    Post: OauthUrl + '/OAuthApi/v1/RivasUserStatus',
  },
  fingerPrint: {
    makeCredentialOptionsV2: OauthUrl + `/makeCredentialOptionsV2`,
    makeCredentialV2: OauthUrl + `/makeCredentialV2`,
    assertionOptionsV2: OauthUrl + `/assertionOptionsV2`,
    makeAssertionV2: OauthUrl + `/makeAssertionV2`,
  },
};

export default apiRoutes;
